module.exports = __webpack_public_path__ + "statics/img/01.17701f37.png";